import React from "react";
import { Avatar, Badge } from "flowbite-react";
import { 
  HiOutlineUser, 
  HiOutlineKey, 
  HiOutlineCash, 
  HiOutlineCreditCard, 
  HiOutlineLogout,
  HiOutlineBell,
  HiOutlineCog
} from "react-icons/hi";

const ProfileSidebar = ({ 
  userInfo, 
  activeTab, 
  handleTabChange, 
  handleLogout,
  notifications 
}) => {
  return (
    <div className="w-full lg:w-64 border-r border-gray-200 dark:border-gray-700">
      <div className="flex flex-col items-center p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="relative">
          <Avatar
            size="xl"
            rounded
            img="https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
            className="mb-3"
          />
          {userInfo && ("isAdmin" in userInfo || userInfo.isModerator) && (
            <Badge
              color={(() => {
                if ("isAdmin" in userInfo) return "purple";
                if (userInfo.isModerator) return "pink";
              })()}
              size="sm"
              className="absolute top-0 right-0"
            >
              {(() => {
                if ("isAdmin" in userInfo) return "Admin";
                if (userInfo.isModerator) return "Moderator";
              })()}
            </Badge>
          )}
        </div>
        <h5 className="text-xl font-medium text-gray-900 dark:text-white">
          {userInfo?.name || "User"}
        </h5>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {userInfo?.email || ""}
        </span>
      </div>
      
      <nav className="space-y-1 p-3">
        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "personal-info"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("personal-info")}
        >
          <HiOutlineUser className="mr-3 h-5 w-5" />
          <span>Personal Info</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "api-key"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("api-key")}
        >
          <HiOutlineKey className="mr-3 h-5 w-5" />
          <span>API Key</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "tokens"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("tokens")}
        >
          <HiOutlineCash className="mr-3 h-5 w-5" />
          <span>Tokens</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "transactions"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("transactions")}
        >
          <HiOutlineCreditCard className="mr-3 h-5 w-5" />
          <span>Payment History</span>
        </button>

        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "notifications"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("notifications")}
        >
          <HiOutlineBell className="mr-3 h-5 w-5" />
          <span className="flex-1 text-left">Notifications</span>
          {notifications.filter(n => !n.read).length > 0 && (
            <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-semibold rounded-full bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100">
              {notifications.filter(n => !n.read).length}
            </span>
          )}
        </button>

        <button
          className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
            activeTab === "settings"
              ? "bg-blue-50 text-blue-700 dark:bg-gray-700 dark:text-blue-400"
              : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          }`}
          onClick={() => handleTabChange("settings")}
        >
          <HiOutlineCog className="mr-3 h-5 w-5" />
          <span>Settings</span>
        </button>
        
        <button
          className="w-full flex items-center px-4 py-3 rounded-lg text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500 transition-colors duration-200 group"
          onClick={handleLogout}
        >
          <HiOutlineLogout className="mr-3 h-5 w-5 group-hover:text-red-700 dark:group-hover:text-white" />
          <span className="group-hover:text-red-700 dark:group-hover:text-white">Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default ProfileSidebar; 